// Пул in-flight запросов с полноэкранным лоадером.
// Ключ — уникальный id запроса (не URL): два параллельных full на один URL
// не схлопываются и не снимают оверлей раньше времени.

// По умолчанию без оверлея: полноэкранный лоадер только при явном loader:'full'.
export const DEFAULT_GLOBAL_LOADER = 'none';

let loadingSeq = 0;

export function resolveLoaderMode(data, defaultMode = DEFAULT_GLOBAL_LOADER) {
  if (data && data.no_loader) {
    return 'none';
  }
  if (data && typeof data.loader !== 'undefined') {
    return data.loader;
  }
  return defaultMode;
}

export function allocLoadingId() {
  loadingSeq += 1;
  return loadingSeq;
}

export function resetLoadingSeq() {
  loadingSeq = 0;
}

export function addActiveLoading(pool, key) {
  pool[key] = (pool[key] || 0) + 1;
}

export function delActiveLoading(pool, key) {
  if (!pool[key]) {
    return;
  }
  pool[key] -= 1;
  if (pool[key] <= 0) {
    delete pool[key];
  }
}

export function hasActiveLoadings(pool) {
  return Object.keys(pool).length > 0;
}
